import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useIntl } from "@edx/frontend-platform/i18n";
import { validatePhoneNumber } from "./extraValidator";

import { FormGroup } from "../../../common-components";
import { clearRegistrationBackendError } from "../../data/actions";

const PhoneNumberField = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const { handleErrorChange } = props;

  const handleOnBlur = (e) => {
    const { value } = e.target;
    const fieldError = validatePhoneNumber(value, formatMessage);
    handleErrorChange("phone_number", fieldError);
  };

  const handleOnFocus = () => {
    handleErrorChange("phone_number", "");
    dispatch(clearRegistrationBackendError("phone_number"));
  };

  return (
    <FormGroup
      {...props}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
    />
  );
};

PhoneNumberField.defaultProps = {
  errorMessage: "",
};

PhoneNumberField.propTypes = {
  errorMessage: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
};

export default PhoneNumberField;
